import { connect } from 'react-redux';

import { resetPracticeExamHistory } from '../../actions/dashboardActions';
import {
  generateCustomPracticeExam,
  getCustomPracticeExamReferences,
  getCustomPracticeExamSettings,
  getWeeklyPracticeExams,
  practiceExamResultsAction,
  setRetakeMode,
  setReviewMode,
  startPracticeExam,
} from '../../actions/practiceExamActions';
import {
  getSwitchPfeSkt,
  getSwitchPfeSktWaiting,
} from '../../components/AccountSettings/AccountSettingsSelectors';
import {
  getCustomPracticeExamHistory,
  getIsLoadingPEHistory,
  getNextWeeklyGenerationAt,
  getPracticeExamsSelector,
  getWeeklyPracticeExamBuildInProgress,
} from '../../components/Dashboard/dashboardSelectors';
import PracticeExamHistoryView from '../../components/Dashboard/PracticeExamHistory/practiceExamHistoryView.jsx';
import {
  getcheckPracticeExamFlag,
  getcheckPracticeExamLoading,
  getCustomPESettings,
  getCustomPracticeExam,
  getCustomPracticeExamLoading,
  getCustomPracticeExamRef,
  getCustomPracticeExamReferencesLoading,
  getCustomPracticeExamSettingsLoading,
  getCustomPracticeExamStatus,
  getPracticeExam,
  getRetakeMode,
  getReviewMode,
} from '../../components/PracticeExam/PracticeExamSelectors';
import { getUser } from '../../components/User/userSelectors';

const mapStateToProps = (state, ownProps) => ({
  customPracticeExamHistory: getCustomPracticeExamHistory(state),
  customPracticeExamStatus: getCustomPracticeExamStatus(state),
  customPracticeExam: getCustomPracticeExam(state),
  loadingPracticeExamHistory: getIsLoadingPEHistory(state),
  user: getUser(state),
  practiceExamFlag: getcheckPracticeExamFlag(state),
  practiceExamRunning: getPracticeExam(state),
  checkPracticeExamLoading: getcheckPracticeExamLoading(state),
  retakeMode: getRetakeMode(state),
  reviewMode: getReviewMode(state),
  exams: getPracticeExamsSelector(state),
  nextWeeklyGenerationAt: getNextWeeklyGenerationAt(state),
  weeklyPracticeExamBuildInProgress:
    getWeeklyPracticeExamBuildInProgress(state),
  pfeSktId: getSwitchPfeSkt(state),
  pfeSktIdWaiting: getSwitchPfeSktWaiting(state),
  customPracticeExamLoading: getCustomPracticeExamLoading(state),
  references: getCustomPracticeExamRef(state),
  isLoadingReferences: getCustomPracticeExamReferencesLoading(state),
  customPESettings: getCustomPESettings(state),
  isLoadingPESettings: getCustomPracticeExamSettingsLoading(state),
});

const mapDispatchToProps = (dispatch) => ({
  startPracticeExam: (userPracticeExamId, practiceExamId, isCustom) =>
    dispatch(startPracticeExam(userPracticeExamId, practiceExamId, isCustom)),
  getWeeklyPracticeExams: () => dispatch(getWeeklyPracticeExams()),
  resetPracticeExamHistory: () => dispatch(resetPracticeExamHistory()),
  setRetakeMode: (value) => dispatch(setRetakeMode(value)),
  practiceExamResults: (examId, retake, isCustom = false) =>
    dispatch(practiceExamResultsAction(examId, retake, isCustom)),
  setReviewMode: (value) => dispatch(setReviewMode(value)),
  regenerateCustomPE: () => dispatch(generateCustomPracticeExam(null, true)),
  generateCustomPE: (chapterIds) =>
    dispatch(generateCustomPracticeExam(chapterIds)),
  loadReferences: (rateId) => dispatch(getCustomPracticeExamReferences(rateId)),
  getCustomPESettings: () => dispatch(getCustomPracticeExamSettings()),
});

const PracticeExamHistoryContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(PracticeExamHistoryView);

export default PracticeExamHistoryContainer;
